// Local preferences for Electron desktop notifications and tray badge.
// Stored in localStorage so they persist across sessions on the same device.

export type DesktopNotifPrefs = {
  retries: boolean;
  failures: boolean;
  synced: boolean;
  newPatients: boolean;
  trayBadge: boolean;
};

export const DEFAULT_DESKTOP_NOTIF_PREFS: DesktopNotifPrefs = {
  retries: true,
  failures: true,
  synced: true,
  newPatients: true,
  trayBadge: true,
};

const KEY = "doctorsx:desktop-notif-prefs:v1";

export function loadDesktopNotifPrefs(): DesktopNotifPrefs {
  if (typeof window === "undefined") return DEFAULT_DESKTOP_NOTIF_PREFS;
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return DEFAULT_DESKTOP_NOTIF_PREFS;
    return { ...DEFAULT_DESKTOP_NOTIF_PREFS, ...JSON.parse(raw) };
  } catch {
    return DEFAULT_DESKTOP_NOTIF_PREFS;
  }
}

export function saveDesktopNotifPrefs(prefs: DesktopNotifPrefs) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(KEY, JSON.stringify(prefs));
    window.dispatchEvent(new CustomEvent("desktop-notif-prefs:changed", { detail: prefs }));
  } catch {
    /* ignore */
  }
}

export function subscribeDesktopNotifPrefs(cb: (p: DesktopNotifPrefs) => void): () => void {
  if (typeof window === "undefined") return () => {};
  const handler = (e: Event) => cb((e as CustomEvent<DesktopNotifPrefs>).detail);
  window.addEventListener("desktop-notif-prefs:changed", handler);
  return () => window.removeEventListener("desktop-notif-prefs:changed", handler);
}
